// Chat feature states for zendesk/chatcreate initialization (internal)
var states = {
  /**
   * Disabled or not-in-use in the app (no chabotID for chatbot)
   */
  OFF: "off",

  /**
   * feature will be used but chat has not yet been triggered on in the host app.
   */
  UNINITIALIZED: "uninitialized",

  /**
   * feature script was added and app is polling to check for related DOM changes.
   */
  LOADING: "loading",

  /**
   * DOM changes were made and feature is ready for use.
   */
  INITIALIZED: "initialized"
}; // Chatbot API constants

var CC_VISIBLE = "cc-visible";
var CC_WINDOW = "cc-window";
var CC_SNIPPET = "cc-snippet"; // Chatbot Action types (internal)

var CHATBOT_LOAD = "chatbot/load";
var CHATBOT_INITIALIZE = "chatbot/initialize"; // Zendesk API constants

var ZE_SNIPPET = "ze-snippet"; // Zendesk visibility states (internal)

var visibility = {
  HIDE: "hide",
  LAUNCHER: "launcher",
  WIDGET: "widget"
}; // Zendesk Action types (internal)

var ZENDESK_LOAD = "zendesk/load";
var ZENDESK_INITIALIZE = "zendesk/initialize";
var ZENDESK_UPDATE_VISIBILITY = "zendesk/update-visibility";
var ZENDESK_SET_LAUNCHER_ELIGIBLE = "zendesk/set-launcher-eligible";
var ZENDESK_UPDATE_DEPARTMENTS = "zendesk/update-departments";
var ZENDESK_UPDATE_NOTIFICATIONS = "zendesk/update-notifications";
var ZENDESK_UPDATE_TAGS = "zendesk/update-tags";
var ZENDESK_UPDATE_IDENTITY = "zendesk/update-identity";
var ZENDESK_UPDATE_UNREAD_COUNT = "zendesk/update-unread-count";
var ZENDESK_UPDATE_LANGUAGE = "zendesk/update-language"; // Universal Action types

var UPDATE_AUTHKEY = "update-authkey";
var SHOW_WIDGET = "show-widget";

export { CC_SNIPPET, CC_VISIBLE, CC_WINDOW, CHATBOT_INITIALIZE, CHATBOT_LOAD, SHOW_WIDGET, UPDATE_AUTHKEY, ZENDESK_INITIALIZE, ZENDESK_LOAD, ZENDESK_SET_LAUNCHER_ELIGIBLE, ZENDESK_UPDATE_DEPARTMENTS, ZENDESK_UPDATE_IDENTITY, ZENDESK_UPDATE_LANGUAGE, ZENDESK_UPDATE_NOTIFICATIONS, ZENDESK_UPDATE_TAGS, ZENDESK_UPDATE_UNREAD_COUNT, ZENDESK_UPDATE_VISIBILITY, ZE_SNIPPET, states, visibility };
